"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Members = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useAnalytics_1 = require("../../../hooks/useAnalytics");
const useAddSubscriber_1 = require("../api/useAddSubscriber");
const useRemoveSubscriber_1 = require("../api/useRemoveSubscriber");
const useSubscriptions_1 = require("../api/useSubscriptions");
const Actors_1 = require("../types/Actors");
const MembersEdit_1 = require("./MembersEdit");
const MembersList_1 = require("./MembersList");
const SubscriptionLoader_1 = require("./SubscriptionLoader");
const Members = (props) => {
    const { entity, subscriptionType, customerID, disableModifySubscribers, displayMode } = props;
    const [subscription, setSubscription] = (0, react_1.useState)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const entityID = entity.id;
    const { data, isLoading } = (0, useSubscriptions_1.useSubscriptions)(entityID);
    const addSubscriberApi = (0, useAddSubscriber_1.useAddSubscriber)(entityID);
    const removeSubscriberApi = (0, useRemoveSubscriber_1.useRemoveSubscriber)(entityID);
    const analytics = (0, useAnalytics_1.useAnalytics)();
    (0, react_1.useEffect)(() => {
        setSubscription(data);
    }, [data]);
    const addSubscriber = (id, idType) => {
        analytics.sendEvent(`${entity.type}-subscriber-add`, {
            id,
            type: idType,
        });
        addSubscriberApi.mutate((0, Actors_1.isFortie)(idType) ? { freightieId: id } : { userId: id });
    };
    const removeSubscriber = (id, idType) => {
        analytics.sendEvent(`${entity.type}-subscriber-remove`, {
            id,
            type: idType,
        });
        let request;
        if ((0, Actors_1.isFortie)(idType)) {
            request = { freightieId: id };
        }
        else if ((0, Actors_1.isContact)(idType)) {
            request = { contact: { id } };
        }
        else {
            request = { userId: id };
        }
        removeSubscriberApi.mutate(request);
    };
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(SubscriptionLoader_1.SubscriptionLoader, {});
    }
    if (!subscription)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(MembersList_1.MembersList, { subscriptionType: subscriptionType, subscription: subscription, removeSubscriber: removeSubscriber, openDialog: () => setOpen(true), disableModifySubscribers: disableModifySubscribers, entityType: entity.type, displayMode: displayMode }), (0, jsx_runtime_1.jsx)(MembersEdit_1.MembersEdit, { open: open, handleClose: () => setOpen(false), subscription: subscription, addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, customerID: customerID, subscriptionType: subscriptionType })] }));
};
exports.Members = Members;
//# sourceMappingURL=Members.js.map